// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oQJ6","icon":"styles_icon__3ncMD"};